module.exports = __webpack_public_path__ + "static/img/xuexiao1@2x.bed56c8e.png";